import React from "react";
import { Col, Row } from "react-bootstrap";
import { NavigationHelper } from "../helpers";
import { AccountSettings, Departments } from "./components";



export const SettingsPage: React.FC = () => {

  React.useEffect(() => { setTimeout(NavigationHelper.showMobileSidebar, 10) }, []) // eslint-disable-line

  return (
    <div className="page-container">
      <div className="page-header">
        <h1><i className="fas fa-cog"></i> Settings</h1>
      </div>
      <Row>
        <Col xs={12} md={6}>
          <AccountSettings />
        </Col>
        <Col xs={12} md={6}>
          <Departments />
        </Col>
      </Row>
    </div>
  );
}